import { App, createApp } from 'vue';
import VueSweetalert2 from 'vue-sweetalert2';
import "../filters/main";
import AlertHelpers from '../plugins/AlertHelpers';
import { AddFilters } from '../filters/numerics';
import { AddFilters as AddStringFilters } from '../filters/strings';
import FormValidatorMixin from '../plugins/FormValidatorMixin';
import VueComponentBase from '~/components/shared/VueComponentBase.vue';
import Mitt from 'mitt';
import $swal, { InternalSwalFactory } from '~/plugins/Swal';
import Features from '~/plugins/Features';
import GlobalConstants from '~/constants/global';
import HealthCheckAPI from '~/api/modules/health_check';

const initVueApp = async (component: any, initFuncs?: Array<(app: App) => void>) => {
  window.$(document).ready(async () => {
    window.EventBus = Mitt();
    const app = createApp({
      extends: component,
      mixins: [FormValidatorMixin]
    }, window.InitialVueProps as any)

    AddFilters(app);
    AddStringFilters(app);

    app.mixin(FormValidatorMixin);
    app.mixin(VueComponentBase as any);
    app.use(VueSweetalert2);
    app.use(AlertHelpers);
    app.use(Features);

    ($swal as InternalSwalFactory).init(app.config.globalProperties.$swal);

    if (initFuncs && initFuncs.length > 0) {
      for (const func of initFuncs) {
        await func(app);
      }
    }
   
    app.mount('#vue-app');

    window.EventBus.on('Session-expired', () => {
      app.config.globalProperties.$swal('Your session has expired', 'Please log back in to continue.', 'warning').then(() => {
        window.location.href = "/"
      });
    });

    window.EventBus.on('Welcome-user', () => {
      app.config.globalProperties.$swal({
        title: "",
        confirmButtonText: "Finish",
        html: `
          <img class="push-30" src="/assets/img/welcome.svg" />
          <h3>Welcome to AdvicePay</h3>
          <p>Thanks for signing up with AdvicePay!</p>
        `,
      });
    });

    window.EventBus.on('Show-app-banner', () => {
      app.config.globalProperties.$swal("Sorry!", window.appBannerContent, 'warning');
    });

    const sessionWatcher = () => {
      // webviews may not have access to local storage. If that's the case, the watcher is pointless.
      if (!window.localStorage) {
        console.error('unable to access local storage');
        return;
      }
      
      const now = new Date().getTime() / 1000;
      let exp = 0;
      try {
        const item = window.localStorage.getItem(GlobalConstants.localStorageKeys.SESSION_EXPIRATION);
        exp = parseInt(item || "0");
        if (isNaN(exp)) {
          exp = 0;
        }
      } catch {
        console.error('unable to write to local storage');
        exp = 0;
      }

      const diff = exp - now;
      if (exp > 0 && diff > 0 && diff < 30) {
        app.config.globalProperties.$swal('Your session will expire in under 30 seconds.', 'Click below to keep your session alive', 'warning').then(() => {
          HealthCheckAPI.get({skipLoader: true});
        });
        setTimeout(() => sessionWatcher(), 10000);
      } else if (exp > 0 && diff < 0) {
        try {
          window.localStorage.removeItem(GlobalConstants.localStorageKeys.SESSION_EXPIRATION);
        } catch {
          console.error('unable to write to local storage');
        }
        window.EventBus.emit('Session-expired');
      } else {
        setTimeout(() => sessionWatcher(), 10000);
      }
    }
    sessionWatcher();
  });
}

export default initVueApp

